module.exports = __webpack_public_path__ + "static/head_to_health-249385dc9c0e0f1824aad6a5a8d850fc.png";